import { useDirectusStore } from "@/modules/directus/store/directus";
import { readItems } from "@directus/sdk";
import { defineStore } from "pinia";
import { watch, ref } from "vue";
import builtIn from "../translations/built-in";
import LanguageInterface from "../interfaces/LanguageInterface";
import { setLocale } from "@vee-validate/i18n";
import { setDefaultOptions } from "date-fns";
import * as dateFnsLocales from "date-fns/locale";
import i18n from "@/plugins/i18n";

export const useLocaleStore = defineStore("locale", () => {
  const directusStore = useDirectusStore();

  const availableLanguages = ref<LanguageInterface[]>([]);

  const updateAvailableLanguages = () => {
    return directusStore.city
      ?.request(
        readItems("languages", {
          fields: ["*"],
        })
      )
      .then((cityAvailableLanguages) => {
        availableLanguages.value = cityAvailableLanguages;
        if (
          !cityAvailableLanguages
            .map((cityAvailableLanguage) => cityAvailableLanguage.code)
            .includes(i18n.global.locale.value)
        ) {
          i18n.global.locale.value = "en";
        }
      });
  };

  watch(
    () => i18n.global.locale.value,
    async (newLocale) => {
      setLocale(newLocale);
      if (newLocale) {
        setDefaultOptions({
          locale: dateFnsLocales[newLocale as keyof typeof dateFnsLocales],
        });
      }
    }
  );

  watch(
    () => directusStore.city,
    async (newCityStore) => {
      updateAvailableLanguages();

      Object.keys(builtIn).forEach((languageCode) => {
        i18n.global.setLocaleMessage(
          languageCode as string,
          builtIn[languageCode as keyof typeof builtIn]
        );
      });

      if (newCityStore) {
        const cityTranslations = await newCityStore.request(
          readItems("translations", { fields: ["*", { language: ["code"] }] })
        );

        const translationsByLanguage = cityTranslations?.reduce(
          (acc: Record<string, Record<string, string>>, translation: any) => {
            if (!acc[translation.language.code]) {
              acc[translation.language.code] = {};
            }
            acc[translation.language.code][translation.key] =
              translation.translation;
            return acc;
          },
          {}
        );

        Object.keys(translationsByLanguage).forEach((languageCode) => {
          i18n.global.mergeLocaleMessage(
            languageCode,
            translationsByLanguage[languageCode]
          );
        });
      }
    }
  );

  // if (localStorage.getItem("locale")) {
  //   i18n.locale.value = localStorage.getItem("locale") as string;
  // }

  return { availableLanguages };
});
